// src/components/info/index.js
import { connect } from 'react-redux'
import { fetchInfo } from './actions'
import Info from './info'
import { 
  getData,
  getDescription,
  getDownload,
  getAddress,
  getSignupPlaceholder,
  getOk,
  getThanks } from './selectors'

const mapStateToProps = state => {
  return {
    data: getData(state),
    description: getDescription(state),
    download: getDownload(state),
    address: getAddress(state),
    signupPlaceholder: getSignupPlaceholder(state),
    okText: getOk(state),
    thanksText: getThanks(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRequestData: () => {
      dispatch(fetchInfo())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Info)



// WEBPACK FOOTER //
// ./src/components/info/index.js